<div class="global-header d-flex flex-column flex-sm-row p-1 bg-white border-bottom rounded" style="height: 160px;">
    <!-- Spinner quand on charge -->
    <div *ngIf="isLoading" class="spinner-container w-100 p-4" style="display: flex; justify-content: center; align-items: center;">
        <div class="spinner-border text-primary" role="status">
            <span class="sr-only"></span>
        </div>
    </div>

    <div *ngIf="!isLoading && fournisseur" class="d-flex flex-column flex-sm-row w-100">
        <!-- Colonne gauche -->
        <div class="left-column d-flex flex-column justify-content-start pe-2 flex-grow-1 gap-3">
            <div class="d-flex align-items-center">
                <h2 class="me-2 mb-0">{{ fournisseur.nom_entreprise || '--' }}</h2>
                <span data-feather="check" class="large-icon text-success m-1"></span>
            </div>

            <!-- EMAIL : bouton toujours visible -->
            <div class="d-flex align-items-center">
                <button type="button" class="email-button me-2">
                    <a *ngIf="fournisseur.emails && fournisseur.emails.length > 0 && fournisseur.emails[0].email; else noEmail"
                       href="mailto:{{fournisseur.emails[0].email}}"
                       target="_blank"
                       class="email"
                       title="Envoyer un mail"
                       style="color: rgba(0, 186, 209, 1);">
                        <span data-feather="user" class="phone-icon"></span>
                    </a>
                    <ng-template #noEmail>
                        <span style="color: rgba(0, 186, 209, 1);">
                            <span data-feather="user" class="phone-icon"></span>
                        </span>
                    </ng-template>
                </button>
                <span class="phone-number">
                    {{ fournisseur.emails && fournisseur.emails.length > 0 ? fournisseur.emails[0].email : '--' }}
                </span>
            </div>

            <!-- TÉLÉPHONE / WHATSAPP : bouton toujours visible -->
            <div class="d-flex align-items-center" style="margin-top: 12px;">
                <button type="button" class="phone-button me-2">
                    <a *ngIf="fournisseur.telephones && fournisseur.telephones.length > 0 && fournisseur.telephones[0].num_tel; else noPhone"
                       [href]="getWhatsAppLink(fournisseur.telephones[0])"
                       target="_blank"
                       class="whatsapp-icon"
                       title="Ouvrir WhatsApp"
                       style="color: rgba(0, 162, 14, 0.9);">
                        <span data-feather="phone" class="phone-icon"></span>
                    </a>
                    <ng-template #noPhone>
                        <span style="color: rgba(0, 162, 14, 1);">
                            <span data-feather="phone" class="phone-icon"></span>
                        </span>
                    </ng-template>
                </button>
                <span class="phone-number">
                    {{ (fournisseur.telephones && fournisseur.telephones.length > 0 ? (fournisseur.telephones[0].code_pays + ' ' + fournisseur.telephones[0].num_tel) : '--') }}
                </span>
            </div>
        </div>

        <!-- Ligne verticale -->
        <div class="vertical-divider d-none d-sm-block"></div>

        <!-- Colonne droite -->
        <div class="right-column d-flex flex-column justify-content-center align-items-center ps-4 gap-2" style="margin-left: 23px; margin-right: 23px;">
            <p class="mb-1 fw-bold">Matricule fiscal</p>
            <span class="phone-number">{{ fournisseur.numero_identification_fiscale || '--' }}</span>
        </div>
    </div>

    <!-- Erreur si aucun fournisseur -->
    <div *ngIf="!isLoading && !fournisseur" class="w-100 p-4 text-center">
        <p class="text-danger">Aucune donnée de fournisseur disponible.</p>
    </div>
</div>
